import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image';
import img1 from './img1.jpg';
import img2 from './img2.jpg';
import img3 from './img3.jpg';
import img4 from './img4.jpg';
export default function Carrusel() {
  return (
    <section className="px-2 py-4 text-center bg-light d-flex justify-content-center align-items-center">
      <Carousel data-bs-theme="dark" style={{ height: "50vh", maxWidth: '1020px', width: '100%' }}>
        <Carousel.Item>
          <Image
            style={{ height: "50vh", objectFit: 'cover' }}
            src={img1}
            fluid />
        </Carousel.Item>
        <Carousel.Item>
          <Image
            style={{ height: "50vh", objectFit: 'cover' }}
            src={img2}
            fluid />
        </Carousel.Item>
        <Carousel.Item>
          <Image
            style={{ height: "50vh", objectFit: 'cover' }}
            src={img3}
            fluid />
        </Carousel.Item>
        <Carousel.Item>
          <Image
            style={{ height: "50vh", objectFit: 'cover' }}
            src={img4}
            fluid />
        </Carousel.Item>
      </Carousel>
    </section>
  )
}
